import Api from '../api';

/**
 * Language Proficiency API Service
 * Handles worker language proficiency API calls
 */

const languageService = {
  /**
   * Get language proficiencies for an employee
   * @param {string} personnelNumber - Employee personnel number
   * @returns {Promise} Axios response with language data
   */
  async getLanguages(personnelNumber) {
    console.log(`🔍 Fetching languages for WorkerId: ${personnelNumber}`);

    try {
      const params = {
        $filter: `WorkerId eq '${personnelNumber}'`,
        'cross-company': true,
      };

      const response = await Api.get('/data/WorkerLanguageProficiencies', { params });
      console.log('✅ Languages fetched:', response.data);
      return response;
    } catch (error) {
      console.error('❌ Error fetching languages:', error);
      throw error;
    }
  },

  /**
   * Get all language proficiencies (for testing)
   * @returns {Promise} Axios response with all language data
   */
  async getAllLanguages() {
    console.log('🔍 Fetching all languages');

    try {
      const params = {
        'cross-company': true,
        $top: 10,
      };

      const response = await Api.get('/data/WorkerLanguageProficiencies', { params });
      console.log('✅ All languages fetched:', response.data);
      return response;
    } catch (error) {
      console.error('❌ Error fetching all languages:', error);
      throw error;
    }
  },
};

export default languageService;
